/*
 * Licensed to Elasticsearch B.V. under one or more contributor
 * license agreements. See the NOTICE file distributed with
 * this work for additional information regarding copyright
 * ownership. Elasticsearch B.V. licenses this file to you under
 * the Apache License, Version 2.0 (the "License"); you may
 * not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import React, { createContext } from 'react';
import PropTypes from "prop-types";
var I18nContext = createContext({});
var EuiI18nProvider = I18nContext.Provider,
    EuiI18nConsumer = I18nContext.Consumer;

var EuiContext = ({
  i18n = {},
  children
}) => <EuiI18nProvider value={i18n}>{children}</EuiI18nProvider>;

EuiContext.propTypes = {
  i18n: PropTypes.shape({
    mapping: PropTypes.shape({}),
    mappingFunc: PropTypes.func,
    formatNumber: PropTypes.func,
    formatDateTime: PropTypes.func,
    locale: PropTypes.string
  }).isRequired,
  children: PropTypes.node.isRequired
};
export { EuiContext, EuiI18nConsumer };

try {
  // @ts-ignore
  context.displayName = "context"; // @ts-ignore

  context.__docgenInfo = {
    "description": "",
    "displayName": "context",
    "props": {
      "i18n": {
        "defaultValue": {
          value: "{}"
        },
        "description": "",
        "name": "i18n",
        "required": false,
        "type": {
          "name": "I18nShape"
        }
      }
    }
  }; // @ts-ignore

  if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["src/components/context/context.tsx#context"] = {
      docgenInfo: context.__docgenInfo,
      name: "context",
      path: "src/components/context/context.tsx#context"
    };
} catch (__react_docgen_typescript_loader_error) {}

try {
  // @ts-ignore
  ExoticComponent.displayName = "ExoticComponent"; // @ts-ignore

  ExoticComponent.__docgenInfo = {
    "description": "",
    "displayName": "ExoticComponent",
    "props": {
      "unstable_observedBits": {
        "defaultValue": null,
        "description": "",
        "name": "unstable_observedBits",
        "required": false,
        "type": {
          "name": "number | undefined"
        }
      }
    }
  }; // @ts-ignore

  if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["src/components/context/context.tsx#ExoticComponent"] = {
      docgenInfo: ExoticComponent.__docgenInfo,
      name: "ExoticComponent",
      path: "src/components/context/context.tsx#ExoticComponent"
    };
} catch (__react_docgen_typescript_loader_error) {}